/**
 * this file holds all redux constants
 * to avoid spelling mistakes when calling reducers & actions
 *
 * Created by Tom on 23/05/18
 */

const constants = {

    // siteTourReducers
    SET_ON_TOUR: 'SET_ON_TOUR',
    SET_ON_TOUR_HIGHLIGHT: 'SET_ON_TOUR_HIGHLIGHT',

    // componentReducer
    SET_OPEN_LEFT_MENU: 'SET_OPEN_LEFT_MENU',
    SET_OPEN_RIGHT_MENU: 'SET_OPEN_RIGHT_MENU',
    SET_OPEN_CONGRATS_INFO: 'SET_OPEN_CONGRATS_INFO',

    // portfolioReducers
    SET_PORTFOLIO_LOADER: 'SET_PORTFOLIO_LOADER',
    FETCH_PORTFOLIO_DATA: 'FETCH_PORTFOLIO_DATA',
    SET_PORTFOLIO_DATA: 'SET_PORTFOLIO_DATA',
    SET_PORTFOLIO_FUND_VALUE: 'SET_PORTFOLIO_FUND_VALUE',
    SET_PORTFOLIO_FETCH_SUCCESS: 'SET_PORTFOLIO_FETCH_SUCCESS',

    // investmentReducers
    SET_INVESTMENT_LOADER: 'SET_INVESTMENT_LOADER',
    FETCH_INVESTMENT_DATA: 'FETCH_INVESTMENT_DATA',
    SET_INVESTMENT_DATA: 'SET_INVESTMENT_DATA',
    SET_INVESTMENT_FETCH_SUCCESS: 'SET_INVESTMENT_FETCH_SUCCESS',

    // transactionReducers
    SET_TRANSACTION_LOADER: 'SET_TRANSACTION_LOADER',
    SET_TRANSACTION_START_DATE: 'SET_TRANSACTION_START_DATE',
    SET_TRANSACTION_END_DATE: 'SET_TRANSACTION_END_DATE',
    FETCH_TRANSACTION_DATA: 'FETCH_TRANSACTION_DATA',
    SET_TRANSACTION_FETCH_SUCCESS: 'SET_TRANSACTION_FETCH_SUCCESS',
    SET_TRANSACTION_DATA: 'SET_TRANSACTION_DATA',
    SET_TRANSACTION_CLOSING_BALANCE: 'SET_TRANSACTION_CLOSING_BALANCE',
    CLEAR_DATE_RANGE: 'CLEAR_DATE_RANGE',

    // newsReducers
    SET_NEWS_LOADER: 'SET_NEWS_LOADER',
    FETCH_NEWS_DATA: 'FETCH_NEWS_DATA',
    SET_NEWS_DATA: 'SET_NEWS_DATA',

    // userReducer
    SET_USER: 'SET_USER',
    SET_USER_PREFERENCES: 'SET_USER_PREFERENCES',

    // profileReducer
    SET_PROFILE_LOADER: 'SET_PROFILE_LOADER',
    FETCH_PROFILE_DATA: 'FETCH_PROFILE_DATA',
    SET_PROFILE_DATA: 'SET_PROFILE_DATA',
    UPDATE_PROFILE: 'UPDATE_PROFILE',
    EDIT_PROFILE: 'EDIT_PROFILE',

    // fundReducer
    SET_FUND_LOADER: 'SET_FUND_LOADER',
    FETCH_FUND_DATA: 'FETCH_FUND_DATA',
    SET_FUND_INFO_DATA: 'SET_FUND_INFO_DATA',
    SET_MEMBERS_TRUSTEES_DATA: 'SET_MEMBERS_TRUSTEES_DATA',


    // notificationsReducer
    SET_NOTIFICATIONS_LOADER: 'SET_NOTIFICATIONS_LOADER',
    FETCH_NOTIFICATIONS_DATA: 'FETCH_NOTIFICATIONS_DATA',
    SET_NOTIFICATIONS_DATA: 'SET_NOTIFICATIONS_DATA',
    DISMISS_NOTIFICATION: 'DISMISS_NOTIFICATION',
    REMOVE_NOTIFICATIONS_PENDING_ACTION: 'REMOVE_NOTIFICATIONS_PENDING_ACTION',

    // documentsReducer
    FETCH_DOC_SIGN_STATUS: 'FETCH_DOC_SIGN_STATUS',
    SET_DOC_SIGN_STATUS: 'SET_DOC_SIGN_STATUS',
    FETCH_DOCUMNENTS_DATA: 'FETCH_DOCUMNENTS_DATA',
    SET_DOCUMNENTS_DATA: 'SET_DOCUMNENTS_DATA',
    SET_DOCUMNENTS_LOADER: 'SET_DOCUMNENTS_LOADER',
    SET_DOCUMENTS_FETCH_SUCCESS: 'SET_DOCUMENTS_FETCH_SUCCESS',

    // billingReducers
    SET_BILLING_LOADER: 'SET_BILLING_LOADER',
    FETCH_BILLING_DATA: 'FETCH_BILLING_DATA',
    SET_BILLING_DATA: 'SET_BILLING_DATA',
    SET_BILLING_FETCH_SUCCESS: 'SET_BILLING_FETCH_SUCCESS',
}

export default constants



// WEBPACK FOOTER //
// ./src/constants.js